(function ($) {
    $.widget('logit.autocomplete', $.Widget, {
        options: {
            url: '',
            fieldname: '',
            minlength: 1,
            limit: 10,
            suggestionTemplate: '',
            emptyTemplate: '',
            tooltipText: '',
            tooltipPlacement: 'top',
            tooltipHighlightClass: 'bold',
            openedCallback: undefined, // Triggered when the dropdown menu of a typeahead is opened.
            closedCallback: undefined, // Triggered when the dropdown menu of a typeahead is closed.
            cursorchangedCallback: undefined, // Triggered when the dropdown menu cursor is moved to a different suggestion. The event handler will be invoked with 3 arguments: the jQuery event object, the suggestion object, and the name of the dataset the suggestion belongs to.
            selectedCallback: undefined,  // Triggered when a suggestion from the dropdown menu is selected. The event handler will be invoked with 3 arguments: the jQuery event object, the suggestion object, and the name of the dataset the suggestion belongs to.
            autocompletedCallback: undefined // Triggered when the query is autocompleted. Autocompleted means the query was changed to the hint. The event handler will be invoked with 3 arguments: the jQuery event object, the suggestion object, and the name of the dataset the suggestion belongs to.
        },

        _create: function () {
            const self = this;

            self.setCallbackValuesIntoSingleAceField = function (element, obj) {
                const inputId = $(element).parents('span.twitter-typeahead').find('.tt-input').attr('id');
                return jsUtils.search.data.setCallbackValuesIntoSingleAceField(inputId, self.options.filterIds, obj, true);
            };

            const engine = this._createEngine();
            self.element.typeahead({
                hint: true,
                highlight: true,
                minLength: self.options.minlength,
            }, {
                source: engine.ttAdapter(),
                templates: {
                    empty: self.options.emptyTemplate,
                    suggestion: Handlebars.compile('<div> ' + self.options.suggestionTemplate + '</div>'),
                },
                displayKey: function (obj) {
                    return self.setCallbackValuesIntoSingleAceField(self.element[0], obj);
                },
                limit: self.options.limit - 1,
            });

            this._initInternalFeatures(engine);
        },


        _initInternalFeatures: function (engine) {
            const self = this;
            this._initCallbacks(self, engine);

            if (self.options.tooltipText) {
                this._createToolTip(self);
            }

            this._addEventHandlers(self, engine);
        },

        _setOption: function (key, value) {
            if ($.Widget.prototype._setOption) {
                this._super(key, value);
            }
        },

        _destroy: function () {
            this.element.off('.logitAutocomplete');
            this.element.typeahead('destroy');
            this.element.tooltip('hide');
            this.element.tooltip('dispose');
        },

        _createToolTip: function (self) {
            const delimiter = jsUtils.search.data.getAceDelimiter();
            const fields = self.options.tooltipText.split(delimiter);
            const title = '<span>' + fields.join('</span>' + delimiter + '<span>') + '</span>';

            // Remove previous tooltip and event handlers
            self.element.tooltip('dispose');

            self.element.tooltip({
                html: true,
                trigger: 'focus',
                title: title,
                placement: self.options.tooltipPlacement
            }).on('keyup.logitAutocomplete focus.logitAutocomplete', function (e) {
                const $el = $(e.target);
                const s = $el.val().split(delimiter);
                const tooltipId = $el.attr('aria-describedby');
                $('#' + tooltipId)
                    .find('.tooltip-inner span')
                    .removeClass(self.options.tooltipHighlightClass);
                $('#' + tooltipId)
                    .find('.tooltip-inner span:nth-child(' + (s.length) + ')')
                    .addClass(self.options.tooltipHighlightClass);
            });
        },

        _initCallbacks: function (self, engine) {
            if (typeof self.options.openedCallback !== 'undefined') {
                self.element.on('typeahead:opened.logitAutocomplete', self.options.openedCallback);
            }
            if (typeof self.options.closedCallback !== 'undefined') {
                self.element.on('typeahead:closed.logitAutocomplete', self.options.closedCallback);
            }
            if (typeof self.options.cursorchangedCallback !== 'undefined') {
                self.element.on('typeahead:cursorchange.logitAutocomplete', self.options.cursorchangedCallback);
            }

            if (typeof self.options.selectedCallback !== 'undefined') {
                self.element.on('typeahead:select.logitAutocomplete', self.options.selectedCallback);
            }
            if (typeof self.options.autocompletedCallback !== 'undefined') {
                self.element.on('typeahead:autocomplete.logitAutocomplete', self.options.autocompletedCallback);
            }

            self.element.on('typeahead:open.logitAutocomplete', function (e) {
                const $input = $(e.currentTarget);

                if ($input.val() !== '' && !$input.data('wasFocusedOnce')) {
                    $input.data('wasFocusedOnce', true);
                    $input.typeahead('close');
                } else {
                    $input.tooltip('show');
                }
            });

            self.element.on('typeahead:close.logitAutocomplete', function (e) {
                $(e.currentTarget).removeData('wasFocusedOnce');
            });

            self.element.on('keydown.logitAutocomplete', function (e) {
                $(e.currentTarget).data('wasFocusedOnce', true);
            });
        },

        _createEngine: function () {
            const self = this;
            const engine = new Bloodhound({
                remote: {
                    url: this.options.url,
                    replace: function (url, uriEncodedQuery) {
                        let updatedUrl = url.replace('%QUERY', encodeURIComponent(uriEncodedQuery));
                        updatedUrl = addAdditionalParameter(updatedUrl, self.options);
                        return updatedUrl;

                        function addAdditionalParameter(url, options) {
                            if (!options.additionalParameter) return url;

                            const val = $('#' + options.additionalParameter).val();
                            if (typeof val === 'undefined') return url;

                            return url + '&' + options.additionalParameter + '=' + encodeURIComponent(val);
                        }
                    }
                },
                datumTokenizer: function () {
                    return Bloodhound.tokenizers.whitespace(self.options.fieldname);
                },
                queryTokenizer: Bloodhound.tokenizers.whitespace
            });

            engine.initialize();
            return engine;
        },

        _addEventHandlers: function (self, engine) {
            self.element.on('keydown.logitAutocomplete', function (event) {
                if (event.keyCode === 13 /* Enter */) {
                    self.element.typeahead('val', self.element.val());
                    self._cancelLastRequest(engine);
                    self._closeSuggestion(self.element);
                    $('.tooltip').tooltip('hide');
                } else {
                    self._openSuggestion(event);
                }
            });

            self.element.on('blur.logitAutocomplete', function () {
                self._closeSuggestion(this);
                self._reinitialize(engine);
            });
        },

        _cancelLastRequest: function (engine) {
            engine.remote.cancelLastRequest();
        },

        _closeSuggestion: function (element) {
            $(element).typeahead('close');
        },

        _openSuggestion: function (event) {
            const self = this;

            if (!self.element.is(':focus')) return;

            const eventObj = window.event ? event : e;
            if ([13, 39, 40].includes(eventObj.keyCode)) {
                self.element.typeahead('open');
            }
        },

        _reinitialize: function (engine) {
            this._destroy();

            engine.clear();
            engine.clearPrefetchCache();
            engine.clearRemoteCache();
            engine.initialize(true);

            this._create();
        }
    });
})(jQuery);
